export const tokenKey = 'assessment_redirect_token';
